module.exports = __webpack_public_path__ + "img/remeras_finales.fb652952.png";